import { FormGroup } from '@angular/forms';

/**
 * Disabilita tutti i campi di un form eccetto quelli elencati nelle eccezioni.
 * @param formGroup Il form su cui operare
 * @param exceptions Array dei nomi dei campi da NON disabilitare
 * @param emitEvent Se true, emette l'evento statusChange (default: false per performance)
 */
export function disableAllExcept(
  formGroup: FormGroup, 
  exceptions: string[] = [], 
  emitEvent: boolean = false
): void {
  Object.keys(formGroup.controls).forEach(key => {
    const control = formGroup.get(key);
    if (!exceptions.includes(key)) {
      control?.disable({ emitEvent });
    } 
  });
}

/**
 * Abilita tutti i campi di un form eccetto quelli elencati nelle eccezioni.
 * @param formGroup Il form su cui operare
 * @param exceptions Array dei nomi dei campi da NON abilitare
 * @param emitEvent Se true, emette l'evento statusChange (default: false per performance)
 */
export function enableAllExcept(
  formGroup: FormGroup, 
  exceptions: string[] = [], 
  emitEvent: boolean = false
): void {
  Object.keys(formGroup.controls).forEach(key => {
    const control = formGroup.get(key);
    if (!exceptions.includes(key)) {
      control?.enable({ emitEvent });
    } 
  });
}